// frontend/src/components/games/tictactoe/ticTacToeAi.ts

import { Player, WIN_LINES } from './tictactoeConstants';

function findWinningMove(board: (Player | null)[], mark: Player): number | null {
  for (const line of WIN_LINES) {
    const marks = line.map((i) => board[i]);
    const markCount = marks.filter((m) => m === mark).length;
    const emptyCount = marks.filter((m) => m === null).length;
    if (markCount === 2 && emptyCount === 1) {
      const emptyIndexInLine = marks.findIndex((m) => m === null);
      return line[emptyIndexInLine];
    }
  }
  return null;
}

export function pickAiMove(board: (Player | null)[], aiMark: Player, humanMark: Player): number {
  const winningMove = findWinningMove(board, aiMark);
  if (winningMove !== null) return winningMove;

  const blockingMove = findWinningMove(board, humanMark);
  if (blockingMove !== null) return blockingMove;

  if (board[4] === null) return 4;

  const corners = [0, 2, 6, 8].filter((i) => board[i] === null);
  if (corners.length > 0) return corners[Math.floor(Math.random() * corners.length)];

  const empties = board.reduce<number[]>((acc, cell, i) => {
    if (cell === null) acc.push(i);
    return acc;
  }, []);
  return empties[Math.floor(Math.random() * empties.length)];
}
